import {
  OtsEntityMultiSelect,
  OtsEntityMultiSelectProps,
  OtsEntitySelect,
  OtsEntitySelectProps,
} from './OtsEntityMultiSelect';

export type OtsSpecificEntitySelectProps = Omit<
  OtsEntitySelectProps,
  'entityType'
>;
export type OtsSpecificEntityMultiSelectProps = Omit<
  OtsEntityMultiSelectProps,
  'entityType'
>;

const createEntitySelect = (entityType: string, displayName: string) => {
  const SpecificEntitySelect = (props: OtsSpecificEntitySelectProps) => (
    <OtsEntitySelect {...props} entityType={entityType} />
  );
  SpecificEntitySelect.displayName = displayName;
  return SpecificEntitySelect;
};

const createEntityMultiSelect = (entityType: string, displayName: string) => {
  const SpecificEntityMultiSelect = (
    props: OtsSpecificEntityMultiSelectProps
  ) => <OtsEntityMultiSelect {...props} entityType={entityType} />;
  SpecificEntityMultiSelect.displayName = displayName;
  return SpecificEntityMultiSelect;
};

export const OtsSiteSelect = createEntitySelect('SITE', 'OtsSiteSelect');
export const OtsSiteMultiSelect = createEntityMultiSelect(
  'SITE',
  'OtsSiteMultiSelect'
);
export const OtsContainerSelect = createEntitySelect(
  'CONTAINER',
  'OtsContainerSelect'
);
export const OtsContainerMultiSelect = createEntityMultiSelect(
  'CONTAINER',
  'OtsContainerMultiSelect'
);
export const OtsRouteSelect = createEntitySelect('ROUTE', 'OtsRouteSelect');
export const OtsRouteMultiSelect = createEntityMultiSelect(
  'ROUTE',
  'OtsRouteMultiSelect'
);
export const OtsCompanySelect = createEntitySelect(
  'COMPANY',
  'OtsCompanySelect'
);
export const OtsCompanyMultiSelect = createEntityMultiSelect(
  'COMPANY',
  'OtsCompanyMultiSelect'
);
export const OtsCompanyUnitSelect = createEntitySelect(
  'COMPANY_UNIT',
  'OtsCompanyUnitSelect'
);
export const OtsCompanyUnitMultiSelect = createEntityMultiSelect(
  'COMPANY_UNIT',
  'OtsCompanyUnitMultiSelect'
);
export const OtsWellSelect = createEntitySelect('WELL', 'OtsWellSelect');
export const OtsWellMultiSelect = createEntityMultiSelect(
  'WELL',
  'OtsWellMultiSelect'
);
export const OtsOperatingAreaSelect = createEntitySelect(
  'OPERATING_AREA',
  'OtsOperatingAreaSelect'
);
export const OtsOperatingAreaMultiSelect = createEntityMultiSelect(
  'OPERATING_AREA',
  'OtsOperatingAreaMultiSelect'
);
export const OtsRouteGroupSelect = createEntitySelect(
  'ROUTE_GROUP',
  'OtsRouteGroupSelect'
);
export const OtsRouteGroupMultiSelect = createEntityMultiSelect(
  'ROUTE_GROUP',
  'OtsRouteGroupMultiSelect'
);
export const OtsMeterSelect = createEntitySelect('METER', 'OtsMeterSelect');
export const OtsMeterMultiSelect = createEntityMultiSelect(
  'METER',
  'OtsMeterMultiSelect'
);
export const OtsFreightTypeSelect = createEntitySelect(
  'FREIGHT_TYPE',
  'OtsFreightTypeSelect'
);
export const OtsFreightTypeMultiSelect = createEntityMultiSelect(
  'FREIGHT_TYPE',
  'OtsFreightTypeMultiSelect'
);
export const OtsServiceTypeSelect = createEntitySelect(
  'SERVICE_TYPE',
  'OtsServiceTypeSelect'
);
export const OtsServiceTypeMultiSelect = createEntityMultiSelect(
  'SERVICE_TYPE',
  'OtsServiceTypeMultiSelect'
);
export const OtsRegionSelect = createEntitySelect('REGION', 'OtsRegionSelect');
export const OtsRegionMultiSelect = createEntityMultiSelect(
  'REGION',
  'OtsRegionMultiSelect'
);
export const OtsPipelineSelect = createEntitySelect(
  'PIPELINE',
  'OtsPipelineSelect'
);
export const OtsPipelineMultiSelect = createEntityMultiSelect(
  'PIPELINE',
  'OtsPipelineMultiSelect'
);
export const OtsContainerClusterSelect = createEntitySelect(
  'CONTAINER_CLUSTER',
  'OtsContainerClusterSelect'
);
export const OtsContainerClusterMultiSelect = createEntityMultiSelect(
  'CONTAINER_CLUSTER',
  'OtsContainerClusterMultiSelect'
);

export const OtsPersonSelect = createEntitySelect('PERSON', 'OtsPersonSelect');
export const OtsVehicleSelect = createEntitySelect('VEHICLE', 'OtsVehicleSelect');
export const OtsVehicleMultiSelect = createEntityMultiSelect(
  'VEHICLE',
  'OtsVehicleMultiSelect'
);
export const OtsTrailerSelect = createEntitySelect('TRAILER', 'OtsTrailerSelect');
export const OtsTrailerMultiSelect = createEntityMultiSelect(
  'TRAILER',
  'OtsTrailerMultiSelect'
);
export const OtsPersonMultiSelect = createEntityMultiSelect(
  'PERSON',
  'OtsPersonMultiSelect'
);
